import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import React, { useContext, useEffect, useRef } from 'react';
import { Alert, FlatList } from "react-native";
import * as ImagePicker from "expo-image-picker";
import { manipulateAsync } from "expo-image-manipulator";
import _ from "lodash";
import WebMedia from "./WebMedia";
import i18n from "@/assets/i18n";
import { MediaContext } from "./MediaContext";
import { getMedia, uploadMedia } from "../../algorithms_and_functions/backend_requests/mediaRequests";
import { loadingImg } from '@/assets/images';

const SIZE = 74

export default function MediaUpload({ nodeId, data, disabled, flowIdForElement, fontSize }) {
    const scrollView = useRef()
    const { media, setMedia, flowId } = useContext(MediaContext)
    const mediaList = media[nodeId] || {}
    const getElementMedia = () => {
        // checklist node => nodeId is a list element Id
        if (flowIdForElement) {
            if (data.listElementMedia && data.listElementMedia[nodeId]) {
                return data.listElementMedia[nodeId]
            }
            return []
        }
        if (data.media) {
            return data.media
        }
        return []
    }
    const elementMedia = getElementMedia()


    const getStepId = (nodeId) => {
        return nodeId.split(/_?element/)[0]
    }

    useEffect(() => {
        if (!data.disabled) {
            async function getMedias() {
                let medias = {}
                for (const mediaId of elementMedia) {
                    if (!mediaList[mediaId]) {
                        const res = await getMedia(mediaId)
                        if (res.ok) {
                            const blob = await res.blob()
                            const url = URL.createObjectURL(blob)
                            // Todo: Klären ob backend Bilder komprimiert oder ich hier
                            medias = { ...medias, [mediaId]: url }
                        } else {
                            medias = { ...medias, [mediaId]: loadingImg }
                        }

                    }
                }

                setMedia((prevState) => {
                    return { ...prevState, [nodeId]: { ...prevState[nodeId], ...medias } }
                })
            }
            getMedias().then()
        }
    }, [data.media, data.listElementMedia])

    const upload = async () => {
        try {
            let result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ImagePicker.MediaTypeOptions.All,
                allowsEditing: true,
                quality: 1,
                exif: false,
            })

            console.log('RESULT IMGS:', result.assets)

            if (!result.canceled) {
                let images = []
                let compressedMedia = {}
                for (const image of result.assets) {
                    const backendImage = await uploadMedia(flowId ? flowId : flowIdForElement, image)
                    if (backendImage?.id) {
                        const extension = image.uri.split(",")[0].split(":")[1].split(";")[0].split("/")[1]
                        const backendImageId = backendImage.id + '.' + (extension == 'quicktime' ? 'mov' : extension)
                        images.push(backendImageId)
                        console.log(extension, backendImageId)

                        if (!image.uri.includes('video/') && !image.uri.includes('audio/')) {
                            const manipulateResult = await manipulateAsync(
                                image.uri,
                                [],
                                { compress: 0.2 } // from 0 to 1 "1 for best quality"
                            )
                            compressedMedia = { ...compressedMedia, [backendImageId]: manipulateResult.uri }
                        } else {
                            compressedMedia = { ...compressedMedia, [backendImageId]: image.uri }
                        }
                    }
                }
                console.log('IMAGES:', images)

                let newNodeData
                if (flowIdForElement) {
                    newNodeData = { ...data, listElementMedia: { ...data.listElementMedia, [nodeId]: elementMedia.concat(images) } }
                } else {
                    newNodeData = { ...data, media: elementMedia.concat(images) }
                }
                console.log('XXX', nodeId, getStepId(nodeId))
                data.updateNode(getStepId(nodeId), newNodeData, true)

                setMedia((prevState) => {
                    return { ...prevState, [nodeId]: { ...prevState[nodeId], ...compressedMedia } }
                })
            }
        } catch (error) {
            Alert.alert(i18n.t('global.error'), '' + error, [{ text: "OK", onPress: () => { }, }])
        }
    }

    const deleteMedia = (index) => {
        let tempMedia = _.cloneDeep(elementMedia)
        const id = tempMedia[index]
        tempMedia.splice(index, 1)
        let newNodeData
        if (flowIdForElement) {
            newNodeData = { ...data, listElementMedia: { ...data.listElementMedia, [nodeId]: tempMedia } }
        } else {
            newNodeData = { ...data, media: tempMedia }
        }
        const newOverlays = { ...data.overlays }
        delete newOverlays[id]
        newNodeData.overlays = newOverlays
        data.updateNode(getStepId(nodeId), newNodeData, true)
    }

    const updateOverlay = (id, overlay) => {
        console.log(id, overlay)
        const newOverlays = { ...data.overlays }
        if (overlay.length == 0) {
            delete newOverlays[id]
        } else {
            newOverlays[id] = overlay
        }
        data.updateNode(getStepId(nodeId), { ...data, overlays: newOverlays }, true)
    }

    const renderItem = ({ item, index }) => {
        return <WebMedia uri={item.uri} id={item.id} size={SIZE + 'px'} className="h-[74px] w-[74px]" disabled={disabled} deleteMedia={data.disabled ? null : deleteMedia} overlay={data?.overlays?.[item.id]} updateOverlay={data.disabled ? null : updateOverlay} index={index} />
    }

    const mediaData = () => {
        return Object.keys(mediaList).filter((id) => { return id.length < 10 ? elementMedia.includes(+id) : elementMedia.includes(id) }).map((id) => {
            return { uri: mediaList[id] || +id, id: id }
        })
    }

    return (
        <View className="m-3">
            {mediaData().length > 0 ?
                <HStack space='xs'>
                    {!disabled && !data.disabled && <Button variant='outline' onPress={() => upload()} className={` h-[74px] w-[74px] border-primary-900 `}>
                        <Text className={`font-bold ${fontSize || 'text-xl'} text-primary-900`}>+</Text>
                    </Button>}
                    <FlatList
                        ref={scrollView}
                        onContentSizeChange={() => scrollView.current?.scrollToEnd()}
                        data={mediaData()}
                        keyExtractor={(item, index) => JSON.stringify(item) + index}
                        renderItem={renderItem}
                        horizontal={true}
                    />
                </HStack>
                :
                !data.disabled &&
                <Pressable onPress={() => upload()} className="m-1 self-center">
                    <Text className={`font-bold ${fontSize || 'text-xl'} text-primary-900`}>+ {i18n.t('studio.editor.addMedia')}</Text>
                </Pressable>
            }
        </View>
    );
}
